import _isEmpty from 'lodash/isEmpty';
import Page from './page';

// Get Remote config data of sh_currency_converter from window
const getCurrencyConverterConfig = () => ((window && window.shCurrencyConverterConfig) || {});

/**
 *  Common function to validate is the market is part of remote config or not.
 * @param markets
 * @returns {boolean}
 */
const isCurrencyConverterEnabledMarket = (markets) => {
  if (!_isEmpty(markets)) {
    const country = (Page.getCountry()).toUpperCase();
    const locale = Page.getAPILocalilty();

    return markets.split(',')
      .filter((market) => market.indexOf(`${country}:`) >= 0)
      .filter((selectedMarket) => selectedMarket.split(':')[1].indexOf(locale) >= 0)
      .length > 0;
  }
  return false;
};

/**
 * Check if FaqId is enabled in RC.
 * @returns {boolean}
 */
const isEnabledFaqId = (ccConfig, faqId) => {
  if (Array.isArray(ccConfig.enabledFaqs)) {
    return (ccConfig.enabledFaqs).indexOf(faqId.toUpperCase()) >= 0;
  }
  return false;
};

/**
 *  check if currency converter is enabled in remote config.
 * @returns {boolean}
 */
const isCurrencyConverterEnabled = (faqId) => {
  try {
    const ccConfig = getCurrencyConverterConfig();
    if (ccConfig && typeof ccConfig === 'object') {
      // check if faqId and market are part of RC.
      return isEnabledFaqId(ccConfig, faqId) && isCurrencyConverterEnabledMarket(ccConfig.enabledMarkets);
    }
    return false;
  } catch (e) {
    return false;
  }
};

export default isCurrencyConverterEnabled;
